import React from 'react';

import { GoogleMapProps } from '@react-google-maps/api';

import MapComponentNew from '../components/MapComponentNew';
import { MappedGolfCourseType } from '../services/apis/golfCourses/types';

// const MapComponent = lazy(() => import('../components/MapComponentNew'));

type MapPropsType = {
  courses: MappedGolfCourseType[];
  hoveredCourse?: string | null;
  center?: GoogleMapProps['center'];
  zoom?: GoogleMapProps['zoom'];
  showMap?: boolean;
};

function Map({ courses, hoveredCourse, center, zoom, showMap }: MapPropsType) {
  return showMap ? (
    <MapComponentNew locations={courses} courseHover={hoveredCourse} center={center} zoom={zoom} />
  ) : null;
}

export default Map;
